import {
  enableNativePush,
  getNativePushPermission,
  isNativePushAvailable,
  syncNativePushToken,
} from "./native-push";
import {
  enableWebPush,
  getWebPushPermission,
  isWebPushAvailable,
  syncWebPushToken,
} from "./web-push";

/**
 * Общий вход для пушей: в приложении — нативные (FCM через Capacitor),
 * в браузере — web push.
 */
export const isPushAvailable = (): boolean =>
  isNativePushAvailable() || isWebPushAvailable();

export const getPushPermission = async (): Promise<NotificationPermission> => {
  if (isNativePushAvailable()) return getNativePushPermission();
  if (isWebPushAvailable()) return getWebPushPermission();
  return "denied";
};

export const syncPushToken = async (): Promise<boolean> => {
  if (isNativePushAvailable()) return syncNativePushToken();
  if (isWebPushAvailable()) return syncWebPushToken();
  return false;
};

/**
 * Запрашивает разрешение. Вызывать по нажатию кнопки: браузеры
 * не показывают запрос без действия пользователя.
 */
export const enablePush = async (): Promise<NotificationPermission> => {
  if (isNativePushAvailable()) return enableNativePush();
  if (isWebPushAvailable()) return enableWebPush();
  return "denied";
};

/**
 * Подтверждение доставки/открытия. Без авторизации: ключ — uuid в URL.
 */
export const ackPush = (url?: unknown): void => {
  if (typeof url !== "string" || !url) {
    return;
  }

  fetch(url, { method: "POST", keepalive: true }).catch(() => {});
};
